import type { RouteRecordComposite } from '@/types/vueRouter';

const getRouteNames = (routes: RouteRecordComposite[]): string[] => routes.reduce(
  (acc, { name }) => (name && typeof name === 'string' ? [...acc, name] : acc), [] as string[],
);

export default getRouteNames;
